import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

// Browser/Mobile
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import BuildIcon from 'material-ui-icons/Mail'

// Actions
import { overlapOpen } from './actions';

class Message extends Component {

  onProfiles = (url) => {
    //this.props.changeRoute('/console/user/'+this.props.data["access id"]+"?open_profile")
    window.open(url);
  }

  onProfilesMobile = (url) => {

    this.props.overlapOpen(false, "0000");
    this.props.changeRoute('/console/user/'+this.props.data["access id"]+"?open_profile")
    //window.open(url);
  }

  render(){
    const { classes, theme, location, data } = this.props;
    let profile_url = data["profile url"];

    if (isBrowser){
      return(
        <Button aria-label="Communication" raised color="primary" onClick={() => this.onProfiles(profile_url)}>
          <BuildIcon className={classes.rightIcon} />
        </Button>
      );
    }

    if (isMobile){
      return(
        <Button aria-label="Communication" raised color="primary" onClick={() => this.onProfilesMobile(profile_url)}>
          <BuildIcon className={classes.rightIcon} />
        </Button>
      );
    }

    return(
      <div>
        <BrowserView>
          <Button aria-label="Communication" raised color="primary" onClick={() => this.onProfiles(profile_url)}>
            <BuildIcon className={classes.rightIcon} />
          </Button>
        </BrowserView>
        <MobileView>
          <Button aria-label="Communication" raised color="primary" onClick={() => this.onProfilesMobile(profile_url)}>
            <BuildIcon className={classes.rightIcon} />
          </Button>
        </MobileView>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        counter: state.counter,
        router: state.router,
        priority: state.dashboard.priority,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    overlapOpen:(open, id) => dispatch(overlapOpen(open, id)),
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps,mapDispatchToProps)(Message)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/Candidate/components/User/scenes/Core/components/Message/index.js